import useAPIs from "./useAPIs";
import WishToaster from "../components/WishToaster";
import { AppUtils } from "./AppUtils";

const useReport = (distributorId) => {
  const { postData, downloadFile } = useAPIs();

  const reportURLList = [
    { key: 1, url: "/reports/my-voucher-report" },
    { key: 2, url: "/reports/volume-report" },
    { key: 3, url: "/reports/team-distributor-report" },
    { key: 4, url: "/reports/fetch-my-votm-order-report" },
    { key: 5, url: "/reports/fetch-my-storelink-order-report" },
    { key: 6, url: "/reports/fetch-my-order-report" },
   
  ];
  const downloadReportURLs = [
    { key: 3, url: "/reports/team-distributor-report-download" },
    { key: 4, url: "/reports/download-my-votm-order-report" },
    { key: 5, url: "/reports/download-my-storelink-order-report" },
    { key: 6, url: "/reports/download-my-order-report" },
    
  ];

  const fetchReport = (URLid, payload, onSuccess, onError) => {
    let URLtoCall = reportURLList.find((item) => item.key === URLid);
    payload.distributor_id = distributorId;
    payload.distributor_ids = distributorId;
    console.log("payload", payload);
    postData(
      URLtoCall?.url,
      payload,
      (data, response) => {
        onSuccess && onSuccess(data, response);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };

  // const downloadReport = (URLid, payload, onSuccess, onError) => {
  //   let URLtoCall = downloadReportURLs.find((item) => item.key === URLid);
  //   console.log(AppUtils.appendParamsToURL(payload, URLtoCall?.url), process.env.REACT_APP_BASE_URL);
  //   window.open(`${process.env.REACT_APP_BASE_URL}${AppUtils.appendParamsToURL(payload, URLtoCall?.url)}`, "_blank");
  // };

  const downloadReport = (URLid, payload, onSuccess, onError) => {
    let URLtoCall = downloadReportURLs.find((item) => item.key === URLid);
    downloadFile(
      `${AppUtils.appendParamsToURL(payload, URLtoCall?.url)}`,
      (data) => {
        onSuccess && onSuccess(data);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const initiateBulkOrderPrint = (payload, onSuccess, onError) => {
    postData(
      "/reports/download-bulk-order",
      payload,
      (data, response) => {
        console.log(data);
        onSuccess && onSuccess(data, response);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  const downloadVolumeReport = (payload, onSuccess, onError) => {
    downloadFile(
      `${AppUtils.appendParamsToURL(payload, "/reports/volume-report-download")}`,
      (data, response) => {
        onSuccess && onSuccess(data, response);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };

  const getCustomerLeads = (payload, onSuccess, onError) => {
    postData(
      "/reports/product-sms",
      payload,
      (data, response) => {
        console.log(data);
        onSuccess && onSuccess(data, response);
      },
      (error) => {
        WishToaster({
          toastMessage: error ? error : "Something went wrong!",
          toastType: "error",
        });
        onError && onError(error);
      }
    );
  };
  return {
    fetchReport,
    downloadReport,
    downloadReportURLs,
    initiateBulkOrderPrint,
    downloadVolumeReport,
    getCustomerLeads,
  };
};

export default useReport;
